const ReportFilters = {

	init: function (){
		this.dateRange.init();
		this.user.init();
		this.groups.init();
		this.courses.init();
	},

	dateRange: {
		$elements: {},

		init: function (){
			// Get element
			this.$elements.dateRange = jQuery( '#ucec-date-range' );

			// Hidden fields
			this.$elements.customRangeStart = jQuery( '#ucec-date-range-custom-start' );
			this.$elements.customRangeEnd   = jQuery( '#ucec-date-range-custom-end' );

			// Check if the required element exists
			if (this.$elements.dateRange.length > 0) {
				// Init select2
				this.select2();

				// Check the Custom Date Range option
				this.bindDateRange();
			}
		},

		bindDateRange: function (){
			// Reference
			let _this = this;

			// Check if the user is selecting
			this.$elements.dateRange.on( 'select2:selecting', function ( event ){
				// Check if the selected option is "custom"
				if (event.params.args.data.id == 'custom') {
					// Prevent default, we don't want to close the select
					event.preventDefault();
				}
				// Check if it's clicking another option
				else {
					// Get datapicker
					let $dataPicker = jQuery( '#ui-datepicker-div' );

					// Hide datepicker
					$dataPicker.hide();
				}
			} );

			// Check click outside
			this.$elements.dateRange.on( 'select2:closing', function ( event ){
				// Get datapicker
				let $dataPicker = jQuery( '#ui-datepicker-div' );

				// Check if there is a datapicker open,
				// if there is then prevent the closing
				if ($dataPicker.length > 0 && $dataPicker.is( ':visible' )) {
					event.preventDefault();
				}

				// If the selected option is custom then update the value of the date fields
				if (_this.$elements.dateRange.val() == 'custom') {
					_this.updateDates();
				} else {
					_this.cleanDates();
				}
			} );
		},

		formatOptions: function ( option ){
			let output;

			// Check if the option is the custom one
			if (option.id == 'custom') {
				// Create HTML for the custom option

				// Get original text
				// We're going to use this because we want to be able to translate this string with PHP
				let originalText = option.text;

				// Create main container
				let container = jQuery( '<span/>', {
					class: 'ucec-report-filter-custom-range'
				} );

				// Top
				let contentTop = jQuery( '<span/>', {
					class: 'ucec-report-filter-custom-range__top',
					text: originalText
				} );

				container.append( contentTop );

				// Bottom
				let contentFields = jQuery( '<span/>', {
					class: 'ucec-report-filter-custom-range__fields',
				} );

				// Start field
				let startField = jQuery( '<input/>', {
					class: 'ucec-report-filter-custom-range__field ucec-report-filter-custom-range__start-date',
					name: 'ucec-report-start-date',
					id: 'ucec-report-start-date',
					readOnly: true,
					placeholder: UO_CEUs.l10n.report.filter.date.startFieldPlaceholder
				} );

				// Check for default value
				let startFieldValue = ReportFilters.dateRange.$elements.customRangeStart.val();

				if (startFieldValue != '') {
					startField.val( startFieldValue );
				}

				// Start date picker
				startField.datepicker( {
					dateFormat: 'd M, y'
				} );

				// Append Start field
				contentFields.append( startField );

				// End field
				let endField = jQuery( '<input/>', {
					class: 'ucec-report-filter-custom-range__field ucec-report-filter-custom-range__end-date',
					name: 'ucec-report-end-date',
					id: 'ucec-report-end-date',
					readOnly: true,
					placeholder: UO_CEUs.l10n.report.filter.date.endFieldPlaceholder
				} );

				// Check for default value
				let endFieldValue = ReportFilters.dateRange.$elements.customRangeEnd.val();

				if (endFieldValue != '') {
					endField.val( endFieldValue );
				}

				// Start date picker
				endField.datepicker( {
					dateFormat: 'd M, y'
				} );

				// Append End field
				contentFields.append( endField );

				// Save button
				let saveButton = jQuery( '<div/>', {
					class: 'ucec-report-filter-custom-range__save',
					text: UO_CEUs.l10n.report.filter.date.saveButton
				} );

				contentFields.append( saveButton );

				// Bind Save
				saveButton.on( 'click', function (){
					// Select "custom"
					ReportFilters.dateRange.$elements.dateRange.val( 'custom' );

					// Close Select2
					ReportFilters.dateRange.$elements.dateRange.select2( 'close' );
				} );

				// Append fields to the container
				container.append( contentFields );

				// Set output
				output = container;
			} else {
				output = option.text;
			}

			return output;
		},

		updateDates: function (){
			// Get values
			let values = {
				start: jQuery( '#ucec-report-start-date' ).val(),
				end: jQuery( '#ucec-report-end-date' ).val()
			}

			// Set values
			ReportFilters.dateRange.$elements.customRangeStart.val( values.start );
			ReportFilters.dateRange.$elements.customRangeEnd.val( values.end );

			// Set "Custom" value
			ReportFilters.dateRange.$elements.dateRange.trigger( 'change.select2' );
		},

		cleanDates: function (){
			// Set values
			ReportFilters.dateRange.$elements.customRangeStart.val( '' );
			ReportFilters.dateRange.$elements.customRangeEnd.val( '' );
		},

		formatSelectedOption: function ( option ){
			let output;

			// Check if the option is the custom one
			if (option.id == 'custom') {
				// Get date values
				let values = {
					start: ReportFilters.dateRange.$elements.customRangeStart.val(),
					end: ReportFilters.dateRange.$elements.customRangeEnd.val()
				}

				// Create text
				let label = UO_CEUs.l10n.report.filter.date.fieldTemplate;

				// Replace variables
				label = label.replace( /%1\$s/, values.start != '' ? values.start : '∞' );
				label = label.replace( /%2\$s/, values.end != '' ? values.end : '∞' );

				// Set value
				output = label;
			} else {
				output = option.text;
			}

			return output;
		},

		select2: function (){
			// Reference main object
			let _this = this;

			this.$elements.dateRange.select2( {
				theme: 'default ucec-select2',
				templateResult: _this.formatOptions,
				templateSelection: _this.formatSelectedOption,
				minimumResultsForSearch: -1,
				escapeMarkup: ( markup ) => {
					return markup
				}
			} ).on('select2:open', function () {
				// Ensure the dropdown is correctly rendered in the DOM
				// Issues with dropdown closing right after opening on some themes.
				setTimeout(() => {
					jQuery('.ucec-select2.select2-container--open .select2-dropdown')
						.css('margin-top', '32px');
				}, 0);
			})
		},
	},

	user: {
		$elements: {},

		init: function (){
			// Get element
			this.$elements.user = jQuery( '#ucec-users' );

			// Check if the required element exists
			if (this.$elements.user.length > 0) {
				// Init select2
				this.select2();
			}
		},

		formatOptions: function ( option ){
			let output;

			// Parse options if it contains user data
			if (option.text.indexOf( '::' ) != -1) {
				// Get user data
				let userData = option.text.split( '::' ),
					user     = {
						name: userData[0],
						email: userData[1],
					};

				// Create container
				const $container = document.createElement( 'span' );
				// Add class
				$container.classList.add( 'ucec-report-filter-users-dropdown' );

				// Add the user name
				$container.innerText = user.name;

				// Add the user email
				const $userEmail = document.createElement( 'span' );
				// Add class
				$userEmail.classList.add( 'ucec-report-filter-users__subtitle' );
				// Add the data
				$userEmail.innerText = user.email;

				// Append the email
				$container.appendChild( $userEmail );

				// Assign jQuery object to .text property
				output = $container;
			} else {
				output = option.text;
			}

			// Return modified option
			return output;
		},

		formatSelectedOption: function ( option ){
			let output;

			// Parse options if it contains user data
			if (option.text.indexOf( '::' ) != -1) {
				// Get user data
				let userData = option.text.split( '::' ),
					user     = {
						name: userData[0],
						email: userData[1],
					};

				// Create container
				const $container = document.createElement( 'span' );
				// Add class
				$container.classList.add( 'ucec-report-filter-users-selected' );

				// Add the user name
				$container.innerText = user.name;

				output = $container;
			} else {
				output = option.text;
			}

			// Return modified option
			return output;
		},

		select2: function (){
			// Reference main object
			let _this = this;

			this.$elements.user.select2( {
				theme: 'default ucec-select2',
				minimumInputLength: 3,
				minimumResultsForSearch: 100,
				templateResult: _this.formatOptions,
				templateSelection: _this.formatSelectedOption,
				escapeMarkup: function ( m ){
					return m;
				},
				ajax: {
					type: 'POST',
					url: UO_CEU_EDITOR.api.root + '/get_select2_users',
					dataType: 'json',
					delay: 250,
					beforeSend: function ( xhr ){
						xhr.setRequestHeader( 'X-WP-Nonce', UO_CEU_EDITOR.api.nonce );
					},
					data: function( params ){
						var query = {
							search: params.term
						}

						// Check if filtering for group leaders.
						if (typeof UO_CEU_EDITOR.group_leader_data !== 'undefined' && UO_CEU_EDITOR.group_leader_data) {
							query.group_leader_users = UO_CEU_EDITOR.group_leader_data.all_user_ids;
						}

						return query;
					},
					cache: true,
					processResults: function( data ){
						// Add the "All users" option
						data.unshift({
							id:   '0',
							text: UO_CEU_EDITOR.l10n.filters.allUsers
						});

						return {
							results: data
						};
					}
				}
			} );
		},
	},

	groups: {
		$elements: {},

		init: function (){
			// Get element
			this.$elements.groups = jQuery( '#ucec-groups' );

			// Check if ther required element exists
			if (this.$elements.groups.length > 0) {
				// Init select2
				this.select2();
			}
		},

		select2: function (){
			this.$elements.groups.select2( {
				theme: 'default ucec-select2'
			} );
		},
	},

	courses: {
		$elements: {},

		init: function (){
			// Get element
			this.$elements.courses = jQuery( '#ucec-courses' );

			// Check if the required element exists
			if (this.$elements.courses.length > 0) {
				// Init select2
				this.select2();
			}
		},

		select2: function (){
			this.$elements.courses.select2( {
				theme: 'default ucec-select2'
			} );
		},
	}
}

export default ReportFilters;